import type { PaymentSummary } from "../features/checkout/payment";

export type SiteConfig = {
  tenantId: string;
  host: string;
  displayName: string;
  timezone: string;
  contactEmail: string | null;
  contactPhone: string | null;
  logoUrl?: string | null;
  payOnlineEnabled: boolean;
  payment: PaymentSummary;
};

export type PostalAddress = {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  county: string;
  formattedAddress: string;
};

export const PostalAddress = {
  isSame(first: PostalAddress, second: PostalAddress): boolean {
    return (
      normalizeAddressPart(first.street) === normalizeAddressPart(second.street) &&
      normalizeAddressPart(first.city) === normalizeAddressPart(second.city) &&
      normalizeAddressPart(first.state) === normalizeAddressPart(second.state) &&
      normalizeAddressPart(first.postalCode) === normalizeAddressPart(second.postalCode)
    );
  },
};

function normalizeAddressPart(value: string): string {
  return value.trim().toUpperCase();
}

export type InvoiceItem = {
  id: string;
  transactionId: string;
  created: string;
  type: string;
  description: string;
  quantity?: number | null;
  unitPrice?: number | null;
  taxAmount?: number | null;
  totalAmount: number;
  reversal: InvoiceItemReversal | null;
  refunds: InvoiceItemRefund[];
};

export type InvoiceItemReversal = {
  id: string;
  created: string;
  description: string;
};

export type InvoiceItemRefund = {
  id: string;
  occurredAtUtc: string;
  description: string;
  amount: number;
};

export type Invoice = {
  id: string;
  code: string;
  reference: string;
  customerId: string;
  billToName: string;
  billToAddress: PostalAddress;
  serviceLocation?: PostalAddress | null;
  serviceLocationName: string | null;
  paymentTermsName: string;
  issuedOn: string;
  dueBy: string;
  notes?: string | null;
  subtotal: number;
  tax: number;
  total: number;
  paid: number;
  balance: number;
  closed: boolean;
  voided: boolean;
  items: InvoiceItem[];
};

export type PortalInvoice = {
  invoice: Invoice;
  accountBalance: number;
};

export type InvoiceLookup = {
  invoice: Invoice;
  accountBalance: number;
  payment: PaymentSummary;
};

export type AccountLookup = {
  customerId: string;
  customerName: string;
  accountBalance: number;
  payment: PaymentSummary;
};

export type PaymentSuccess = {
  invoice: Invoice | null;
  accountBalance: number;
  paymentId: string;
  paymentAmount: number;
  amountApplied: number;
  surchargeAmount?: number | null;
};

export type SecureSessionStatus = {
  lockedOut: boolean;
  lockedUntil?: string | null;
  message: string;
};
